import { render, staticRenderFns } from "./faqFour.vue?vue&type=template&id=42cca550&"
import script from "./faqFour.vue?vue&type=script&lang=js&"
export * from "./faqFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports